import React, { FC } from 'react';
import styled from 'styled-components';

const ErrorMessage = styled.div`
    color: #b00020;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 10px;
    padding: 3px 5px;
    width: 100%;
`;

interface LabelValidatorProps {
    isValid?: {
        valid: boolean;
        message?: string;
    };
}

export const LabelValidator: FC<LabelValidatorProps> = ({ isValid }) => {
    return (
        <>
            {!isValid?.valid && isValid?.valid !== undefined ? (
                <ErrorMessage>{isValid?.message}</ErrorMessage>
            ) : null}
        </>
    );
};
